export default {
  getAccount: (state) => state.account,
};
